"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _base = _interopRequireDefault(require("@emotion/styled/base"));

var _react = _interopRequireWildcard(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _framerMotion = require("framer-motion");

var _plaintexttohtml = _interopRequireDefault(require("@ckeditor/ckeditor5-clipboard/src/utils/plaintexttohtml"));

var _propTypes = require("prop-types");

var _Dropdown = _interopRequireDefault(require("../Dropdown/Dropdown"));

var _Editor = _interopRequireDefault(require("../Editor/Editor"));

var _Field = require("../Field/Field");

var _Field2 = require("../Field/Field.styles");

var _Help = _interopRequireDefault(require("../Field/Help/Help"));

var _FieldWithVariables = require("./FieldWithVariables.styles");

var _strings = require("../../util/strings");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Menu = _Dropdown["default"].Menu;

var menu = function menu(data) {
  return (0, _jsxRuntime.jsx)(Menu, {
    children: data.map(function (item) {
      return (0, _jsxRuntime.jsx)(Menu.Item, {
        itemKey: item.key,
        item: item,
        children: item.title
      }, item.key);
    })
  });
};

var FieldContainer = (0, _base["default"])("div", {
  target: "e1b6zmrb0",
  label: "FieldContainer"
})(_Field2.styles.fieldContainer, ";width:100%;", _Field.FormControl, "{&>*{width:100%;}}");
var config = {
  forcePasteAsPlainText: true
}; // otherProps are for editor

var FieldWithVariables = function FieldWithVariables(_ref) {
  var className = _ref.className,
      variableList = _ref.variableList,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus,
      value = _ref.value,
      onChange = _ref.onChange,
      name = _ref.name,
      label = _ref.label,
      validateStatus = _ref.validateStatus,
      help = _ref.help,
      disabled = _ref.disabled,
      fieldContainerClassName = _ref.fieldContainerClassName,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref, ["className", "variableList", "onBlur", "onFocus", "value", "onChange", "name", "label", "validateStatus", "help", "disabled", "fieldContainerClassName"]);

  var _useState = (0, _react.useState)(value),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      editorData = _useState2[0],
      setEditorData = _useState2[1];

  var editorRef = (0, _react.useRef)();

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      dropdownVisible = _useState4[0],
      setDropdownVisible = _useState4[1]; // Only show insert dropdown button when the input is focused


  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      showInsertButton = _useState6[0],
      setShowInsertButton = _useState6[1];

  var handleInsertVariable = (0, _react.useCallback)(function (key) {
    var editor = editorRef.current;
    editor.execute('placeholder', {
      value: key
    });
    editor.editing.view.focus();
    setDropdownVisible(false);
  }, []);
  var handleReady = (0, _react.useCallback)(function (editor) {
    editorRef.current = editor; // Remove event for enter and shift-enter to make sure only allow one line

    editor.editing.view.document.on('enter', function (evt, data) {
      data.preventDefault();
      evt.stop();
    }, {
      priority: 'highest'
    });
    editor.editing.view.document.on('clipboardInput', function (_, data) {
      if (editor.isReadOnly) {
        return;
      } // Paste data as plain text


      var content = (0, _plaintexttohtml["default"])(data.dataTransfer.getData('text/plain')); // eslint-disable-next-line no-param-reassign

      data.content = editor.data.htmlProcessor.toView(content.replace(/<br>/g, ' ') // only allow one line just like input
      );
    }, {
      priority: 'highest'
    });
  }, []);
  var handleFocus = (0, _react.useCallback)(function (e) {
    onFocus(e);
    setShowInsertButton(true);
  }, [onFocus]);
  var handleBur = (0, _react.useCallback)(function (e) {
    var currentTarget = e.currentTarget;
    e.persist(); // https://gist.github.com/pstoica/4323d3e6e37e8a23dd59
    // Check the newly focused element in the next tick of the event loop

    setTimeout(function () {
      // Check if the new activeElement is a child of the original container
      if (!currentTarget.contains(document.activeElement)) {
        // Trigger blur event for validation
        var event = Object.assign(e, {
          target: {
            name: name
          }
        });
        onBlur(event); // Hide insert dropdown button

        setShowInsertButton(false);
      }
    }, 0);
  }, [onBlur, name]);
  var handleEditorDataChange = (0, _react.useCallback)(function (e, editor) {
    if (editor) {
      var editorDataString = editor.getData();
      setEditorData(editorDataString);
      var event = Object.assign(e, {
        target: {
          name: name,
          value: (0, _strings.stripHTML)(editorDataString)
        }
      });
      onChange(event);
    }
  }, [name, onChange]);
  return (0, _jsxRuntime.jsxs)("div", {
    className: (0, _clsx["default"])(className, 'grui flex items-end'),
    onBlur: handleBur,
    children: [(0, _jsxRuntime.jsxs)(FieldContainer, {
      className: fieldContainerClassName,
      children: [label && (0, _jsxRuntime.jsx)("div", {
        css: _Field2.styles.labelBox,
        children: label
      }), (0, _jsxRuntime.jsx)(_Field.FormControl, {
        validateStatus: validateStatus,
        disabled: disabled,
        children: (0, _jsxRuntime.jsx)(_Editor["default"], _objectSpread(_objectSpread({}, otherProps), {}, {
          isToolbarHidden: true,
          showPluginVariablesPlaceholder: true,
          onReady: handleReady,
          onFocus: handleFocus,
          editorData: editorData,
          onEditorDataChange: handleEditorDataChange,
          config: config,
          css: _FieldWithVariables.styles.field
        }))
      }), help && (0, _jsxRuntime.jsx)(_Help["default"], {
        help: help,
        validateStatus: validateStatus
      })]
    }), (0, _jsxRuntime.jsx)("div", {
      className: "grui ml-5",
      children: (0, _jsxRuntime.jsx)(_framerMotion.AnimatePresence, {
        children: showInsertButton && (0, _jsxRuntime.jsx)(_framerMotion.motion.div, {
          initial: {
            opacity: 0
          },
          animate: {
            opacity: 1
          },
          exit: {
            opacity: 0
          },
          transition: {
            duration: 0.3
          },
          children: (0, _jsxRuntime.jsx)(_Dropdown["default"], {
            overlay: menu(variableList),
            type: "secondary",
            visible: dropdownVisible,
            onVisibleChange: setDropdownVisible,
            onSelect: handleInsertVariable // Need to add margin to make dropdown in the same level with input when there is help message
            ,
            className: (0, _clsx["default"])({
              'grui mb-13': help
            }),
            children: (0, _jsxRuntime.jsx)(_Dropdown["default"].Button, {
              size: "big",
              children: "Insert variable"
            })
          })
        })
      })
    })]
  });
};

FieldWithVariables.propTypes = {
  className: _propTypes.string,
  fieldContainerClassName: _propTypes.string,
  variableList: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    key: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
    title: _propTypes.string
  })),
  onBlur: _propTypes.func,
  onFocus: _propTypes.func,
  value: _propTypes.string,
  onChange: _propTypes.func,
  name: _propTypes.string,
  label: _propTypes.string,
  validateStatus: (0, _propTypes.oneOf)(['success', 'error']),
  help: _propTypes.string,
  disabled: _propTypes.bool
};
FieldWithVariables.defaultProps = {
  className: undefined,
  fieldContainerClassName: undefined,
  variableList: [],
  onBlur: function onBlur() {},
  onFocus: function onFocus() {},
  value: '',
  onChange: function onChange() {},
  name: '',
  label: '',
  validateStatus: undefined,
  help: undefined,
  disabled: false
};
var _default = FieldWithVariables;
exports["default"] = _default;
//# sourceMappingURL=FieldWithVariables.js.map